<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="epigraph">
<p class="ct"><a class="xref" href="#/OEBPS/pppsorrowend0006#toc">Epigraph</a></p>
<div class="epigraph">
<p class="ep">“Once to die is better than length of days<br class="calibre1"/>in sorrow without end.”</p>
<p class="ept">Aeschylus, <em class="calibre4">Prometheus Bound</em>, 1.750-1<br class="calibre1"/><br class="calibre1"/>From Chambers <em class="calibre4">Dictionary of Quotations,</em><br class="calibre1"/>translator unknown</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-sorrowend0004.vue?1005f1ca